﻿import React, { useState } from 'react';

import styleVars_7 from "styles/colors.module.scss";
const { turquoise01  } = styleVars_7;;
import TextInput from './TextInput';
import { SearchIcon } from 'components/Icon';

const SearchInput = ({
  onChange, // eslint-disable-line react/prop-types
  ...others
}) => {
  const [typingTimeout, setTypingTimeout] = useState();
  return (
    <TextInput
      placeholder="Search a client"
      icon={<SearchIcon fill={turquoise01} />}
      onChange={(ev) => {
        const value = ev.target.value;
        if (typingTimeout) {
          clearTimeout(typingTimeout);
        }
        setTypingTimeout(setTimeout(() => {
          onChange(value);
        }, 1000));
      }}
      {...others}
    />
  );
};

export default SearchInput;
